const academicLevelsData = [
    { id: "1", name: "Foundation" },
    { id: "2", name: "Certificate" },
    { id: "3", name: "Diploma" },
    { id: "4", name: "Higher National Diploma (HND)" },
    { id: "5", name: "Associate Degree" },
    { id: "6", name: "Advanced Diploma" },
    { id: "7", name: "Bachelor's Degree" },
    { id: "8", name: "Professional Degree" },
    { id: "9", name: "Postgraduate" },
    { id: "10", name: "Master's Degree" },
    { id: "11", name: "Doctoral (PhD)" },
    { id: "12", name: "Postdoctoral" },
    { id: "13", name: "Vocational Training" }
];
  
export default academicLevelsData;